var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f1eadd;\n        stroke: #2d312d;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.5,
    y: 1.5,
    width: 381,
    height: 215,
    rx: 20.37,
    ry: 20.37
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraEmpty);
export default __webpack_public_path__ + "static/media/camera_empty.7ba7934e17bffb4752645de97097f5f7.svg";
export { ForwardRef as ReactComponent };